// extracted by mini-css-extract-plugin
export default {"transport-info":"styles_transport-info__U+ybw","info-container":"styles_info-container__V2Fm2","number":"styles_number__x8+GY","route":"styles_route__dxaVz"};